import { render } from "./Logo.vue?vue&type=template&id=31ab1475"
const script = {}

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__